export const GET_UNUM_GET_PLANS_KEY = 'UNUM_GET_PLANS';
